import React from 'react';
import css from './GoToSource.module.scss';
import Chip from "@material-ui/core/Chip";
import Tooltip from "@material-ui/core/Tooltip";
import chrome from "../../../assets/images/extra/chrome.png";
import java from "../../../assets/images/extra/java-coffee-cup-logo.png";
import webStorm from "../../../assets/images/extra/webstorm.png";
import intellij from "../../../assets/images/extra/intellij.png";
import goToSource from "../../../assets/images/projectsImage/goToSource.gif";

const GoToSource: React.FC = () => (
    <div className={css.project} id="goToSource">
        <img src={goToSource} alt=""/>

        <div className={css.projectInformationContainer}>
            <div className={css.projectName}>
                <h3>Go To Source</h3>
            </div>

            <div className={css.info}>
                <Chip label="Nov. 2019 - Feb. 2020" size='small' variant="outlined"/>
            </div>

            <div className={css.infoSmallScreen}>
                <Chip label="Nov. 2019 - Feb. 2020" size='small' variant="outlined"/>
            </div>

            <h5 className={css.textSectionInfo}>Description:</h5>
            <p className={css.description}>
                This solution for front end developers who want's to improve their productivity, using it will allow
                them to navigate From web Page to the code responsible for managing that section, located in their IDEs.
            </p>

            <p className={css.description}>
                Unfortunately, it is only usable with chrome browser and JetBrains Products (like Intellij and
                WebStrom).
            </p>

            <div className={css.learnMoreLink}>

                <p>Demo: <a className={css.link}
                                   href='https://www.youtube.com/watch?v=HgdkF66UMsc&list=PLIe1MBuMIbgjZCM4fYj7r1-JMq2y6b4mf&index=1&ab_channel=MedY%C3%A9ssineBenKhalifa'
                                   rel="noopener noreferrer"
                                   target="_blank">video</a>
                </p>
                <p>Source Code: <a className={css.link}
                                   href='https://www.github.com/adhess/goToSource'
                                   rel="noopener noreferrer"
                                   target="_blank">https://www.github.com/adhess/goToSource</a>
                </p>

            </div>

            <h5 className={css.textSectionInfo}>Keywords:</h5>
            <div className={css.keywords}>
                <Tooltip title="Chrome Extension">
                    <img src={chrome} alt=""/>
                </Tooltip>
                <Tooltip title="Java">
                    <img src={java} alt=''/>
                </Tooltip>
                <Tooltip title="WebStorm">
                    <img src={webStorm} alt=""/>
                </Tooltip>
                <Tooltip title="Intellij">
                    <img src={intellij} alt=""/>
                </Tooltip>
            </div>

        </div>
    </div>
);

export default GoToSource;
